import { render } from "./Badge.vue?vue&type=template&id=6cb3fe23&scoped=true"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"

import "./Badge.vue?vue&type=style&index=0&id=6cb3fe23&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb3fe23"],['__file',"src/components/Badge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cb3fe23"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cb3fe23', __exports__)) {
    api.reload('6cb3fe23', __exports__)
  }
  
  module.hot.accept("./Badge.vue?vue&type=template&id=6cb3fe23&scoped=true", () => {
    api.rerender('6cb3fe23', render)
  })

}


export default __exports__